import { css } from '@emotion/react'
import { rem } from '@groovehq/internal-design-system/lib/util/strings'

const container = theme => css`
  width: 100%;
  height: 100%;
  background-color: ${theme.color.monochrome.white};
  padding: ${rem(177)} ${rem(20)} ${rem(60)};
`

const innerContainer = css`
  display: flex;
  justify-content: center;
  align-items: center;
`

const btn = theme => css`
  padding-left: ${rem(40)};
  padding-right: ${rem(40)};
  border-radius: ${rem(24)};
  margin-top: ${rem(16)};
  font-family: ${theme.font.gtWalsheimPro};
`

const content = theme => css`
  max-width: ${rem(530)};

  h2 {
    font-size: ${theme.fontSize.x7large};
  }
  & > p {
    margin-bottom: ${rem(25)};
  }
`

const imgWrapper = css`
  margin-left: ${rem(22)};
  width: ${rem(580)};
  img {
    width: 100%;
  }
`

export const styles = {
  container,
  innerContainer,
  btn,
  content,
  imgWrapper,
}
